// import { hasValue } from '../scripts/utilities';
import * as Utilities from '../scripts/utilities';
import { Lookup } from './lookup.interface';

export interface AishRelationLookup extends Lookup {
  parentGuardian?: boolean;
  spousePartner?: boolean;
  professional?: boolean;
}

export interface AishContactOptionsLookup extends Lookup {
  me?: boolean;
  applicant?: boolean;
  spousePartner?: string; //to handle conditional display text based on the options below
}

export const RelationOptions: { [name: string]: AishRelationLookup } = {
  professionalRepresentative: {
    code: 'professionalRepresentative',
    displayValue: 'I am a professional representative',
    professional: true,
  },
  parentGuardian: {
    code: 'parentGuardian',
    displayValue: 'I am their parent/guardian',
    parentGuardian: true,
  },
  spousePartner: {
    code: 'spousePartner',
    displayValue: 'I am their spouse/partner',
    spousePartner: true,
  },
  friendFamily: {
    code: 'friendFamily',
    displayValue: 'I am a friend or family member',
  },
};

export const RelationContactOptions: { [name: string]: AishContactOptionsLookup } = {
  me: {
    code: 'me',
    displayValue: 'Me',
    me: true,
    spousePartner: 'Me (We will collect your contact details on another page)',
  },
  applicant: { code: 'applicant', displayValue: '<<oboName>>', applicant: true },
};

export function RelationContactOptionDisplay(key: string, relationshipType?: string) {
  let displayValue = RelationContactOptions[key]?.displayValue;
  if (Utilities.hasValue(relationshipType) && Utilities.hasValue(RelationContactOptions[key][relationshipType])) {
    displayValue = RelationContactOptions[key][relationshipType];
  }
  return displayValue;
}
